import { ProductionSidePanel } from "components/SidePanel/Production/ProductionSidePanel";
import moment from "moment";
import { ProductionDateRange } from "Production/components/ProductionDateRange";
import React from "react";

interface Props {
  production: server.dto.TourSmall
}

const ReadonlyProduction = (props: Props) => {
  const { production } = props;

  const startDate = production.startDate ? moment.utc(production.startDate) : null;
  const endDate = production.endDate ? moment.utc(production.endDate) : null;

  return <>
    <ProductionSidePanel
      productionId={production.productionId}
      trigger={<a onClick={() => { }}>{production.name}</a>}
      fallbackIfNoPermission={<span>{production.name}</span>  }
    />
    <ProductionDateRange
      startDate={startDate}
      endDate={endDate}
    />
  </>;
};

export default ReadonlyProduction;